import { FC } from 'react';
import { Image } from 'atoms/Image/Image';
import playIcon from './playIcon.png';

export const YoutubePlayButton: FC<{ className?: string }> = ({
  className = '',
}) => {
  return (
    <Image
      src={playIcon.src}
      width={64}
      height={64}
      alt="play"
      className={className}
    />
  );
};
